import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PAYMENT_FLOWS_QUERY_KEY} from "../queryKeys";
import {PaymentFlow, PaymentFlowType} from "./types";

type Data<T extends PaymentFlowType> = PaymentFlow<T>[];

type Variables<T extends PaymentFlowType> = {
  type: T;
};

const getPaymentFlows = async <T extends PaymentFlowType>(variables: Variables<T>): Promise<Data<T>> => {
  const response = await axiosReachInstance.get<Data<T>, AxiosResponse<Data<T>>>("/payment_flows", {
    params: {type: variables.type},
  });
  return response.data;
};

export const useGetPaymentFlows = <T extends PaymentFlowType>(
  variables: Variables<T>,
  options?: BaseQueryOptions<Data<T>, Variables<T>>
): BaseUseQueryResult<Data<T>> => {
  return useBaseQuery<Data<T>, Variables<T>>(
    [PAYMENT_FLOWS_QUERY_KEY, variables.type],
    getPaymentFlows,
    variables,
    options
  );
};
